import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { getUserMe } from '@/composables/userApi'
type UserType = {
  _id: string
  username: string
  email: string
  role: string
  address: string
  bio: string
  facebook_id: string
  github_id: string
  google_id: string
  name: string
  phone: string
}
const baseUser = useStorage('phiethoc_client', {} as UserType)

export const useUser = defineStore('user', {
  state: () => ({
    user: {} as UserType,
  }),
  getters: {
    getInformation: (state) => state.user,
  },
  actions: {
    setUserData() {
      watch(
        baseUser,
        (value) => {
          this.user = value
        },
        { immediate: true },
      )
    },
    async getUserInfo() {
      try {
        const res = await getUserMe()
        baseUser.value = res.data
        this.setUserData()
      } catch (error) {}
    },
    removeUserInfo() {
      const phiethoc_token = useCookie('phiethoc_client')
      phiethoc_token.value = ''
      baseUser.value = null
      this.setUserData()
    },
  },
})
